import "./home.css";
import Body from "../body/body";

import Header from "../header/header";
import Footer from "../footer/footer";
import TopPage from "../../Components/topPage/topPage";
import { WhiteLabelContext } from "../../context/index";
import { useContext } from "react";

function Home() {
  const context = useContext(WhiteLabelContext);
  return (
    <html lang="pt-BR">
      <div className="Home">
        <Header contexto={context.whitelabel} />
        <Body contexto={context.whitelabel} />
        <Footer contexto={context.whitelabel} />
        <TopPage />
      </div>
    </html>
  );
}

export default Home;
